import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import Util from '../../../util'
import './InvestmentPlan.css'
import NavigatorMain from '../../NavigatorMain';
import { getInvestmentList } from '../../../action/myAssets/InvestPlanAction.js';
import {bankCode} from '../../../BankCode';
class InvestmentPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  componentWillMount(){
    this.props.dispatch(getInvestmentList())
    document.title= "定投计划";
    console.log(this.props.inInvestmentList)
  }
  selectFund(){
    hashHistory.push({
      pathname: '/InvestmentFund',
      state: {
      }
    });
  }
  push(item){
    console.log(item)
    hashHistory.push({
      pathname: '/InvestmentDetail',
      state: {
        planId:item.planId,
        name:item.fundName,
        code:item.fundCode,
        planItem:item
      }
    });
  }
  render(){
    console.log(this.props.inInvestmentList)

    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>定投计划</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content paddB40'>
            {
              this.props.inInvestmentList.content.records.map((item,i)=> {
                let arr=['','','一','二','三','四','五']
                let str='';
                if (item.periodType=='0') {
                  str='每月'+item.tradeDates[0]+'日';
                } else if (item.periodType=='1') {
                  str='每周周'+arr[item.tradeDates[0]]
                  
                } else if (item.periodType=='3'){
                  str='每双周周'+arr[item.tradeDates[0]]
                }
                return(
                  <div className='plan-info' key={'plan-info'+i} onClick={()=>this.push(item)}>
                    <div className='plan-info-header'>
                    {
                      item.type=='11'||item.type=='2'?<div className='plan-info-header-left'>
                        <img src={require('../../../img/hqt.png')} style={{width:24,height:31,marginRight:5,marginLeft:5}}/>
                        <p>{item.convertOutFundName}<span style={{fontSize:12,color:'#5b6370'}}>{'('+Util.formatStr(item.trustChannelName)+')'}</span></p>
                      </div>:<div className='plan-info-header-left'>
                        <img src={bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')} />
                        <p>{item.trustChannelName}</p>
                      </div>
                    }
                      
                      <div className='plan-info-header-center'>
                        <div className='plan-info-header-center-top' >
                          <p >{str}</p>
                        </div>
                        <div className='plan-info-header-center-bottom' >
                          <p >{item.tradeAmount}元</p>
                        </div>
                      </div>
                      <div className='plan-info-header-right'>
                          <p>{item.fundName}</p>
                      </div>
                    </div>
                    <div className='plan-info-footer'>下一扣款日:{Util.returnDate(item.nextTradeDate) }</div>
                  </div>
                )
              })
            }
            {
            this.props.inInvestmentList.content.records.length==0?
              <div className='plan-tip'>您还没有创建过定投计划，点击底部按钮立即创建</div>
              :null
            }
          </div>
          <div className='btn2' onClick={()=>this.selectFund()}>
            新建定投计划
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
   inInvestmentList:state.InvestPlanReducer.inInvestmentList
  }
}
export default connect(mapStateToProps)(InvestmentPlan);



// WEBPACK FOOTER //
// ./src/components/myAssets/investPlan/InvestmentPlan.js